import React, { createContext, useState, useContext } from "react";
import DialogComponent from "./DialogComponent";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: () => {},
    cancelText: "",
    okText: "",
  });

  const openDialog = ({ title, message, onConfirm, cancelText, okText }) => {
    setDialogState({
      open: true,
      title,
      message,
      onConfirm,
      cancelText,
      okText,
    });
  };

  const closeDialog = () => {
    setDialogState({ ...dialogState, open: false });
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      <DialogComponent
        open={dialogState.open}
        title={dialogState.title}
        message={dialogState.message}
        onClose={closeDialog}
        onConfirm={dialogState.onConfirm}
        cancelText={dialogState.cancelText}
        okText={dialogState.okText}
      />
    </DialogContext.Provider>
  );
};

export const useDialog = () => useContext(DialogContext);
